import { render, staticRenderFns } from "./GenericDocumentModal.vue?vue&type=template&id=7fcc6b39&scoped=true"
import script from "./GenericDocumentModal.vue?vue&type=script&lang=ts"
export * from "./GenericDocumentModal.vue?vue&type=script&lang=ts"
import style0 from "./GenericDocumentModal.vue?vue&type=style&index=0&id=7fcc6b39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcc6b39",
  null
  
)

export default component.exports